module.exports = __webpack_public_path__ + "a8a10a3e/img/ion_calendar-number.3ac5bd07.svg";